import { dateToFilterFormat } from '@/composables/useDateService'
import { ProductWithSuppliers } from './suppliers'

export const PurchaseOrder = (data: IPurchaseOrder): IPurchaseOrderModel => {
	const {
		average_coverage,
		can_be_cancelled,
		can_be_edited,
		can_be_merged,
		created_at,
		delivery_deadline,
		ordered_at,
		status_label,
		updated_at,
		total_amount,
		group_by_date,
		production_plan,
		production_simulation_version,
		priority,
		items,
		items_count,
		merged_into_purchase_order_id,
		merge_sources_count,
		merge_sources_names,
		...rest
	} = data

	return {
		...rest,
		averageCoverage: average_coverage,
		canBeCancelled: can_be_cancelled,
		canBeEdited: can_be_edited,
		canBeMerged: can_be_merged ?? false,
		createdAt: created_at,
		deliveryDeadline: delivery_deadline,
		orderedAt: ordered_at,
		statusLabel: status_label,
		updatedAt: updated_at,
		totalAmount: total_amount,
		groupByDate: group_by_date,
		productionPlan: production_plan,
		productionSimulationVersion: production_simulation_version ?? null,
		priority,
		items: items?.map((item: IProductWithSuppliers) => ProductWithSuppliers(item)) ?? [],
		itemsCount: items_count ?? items?.length ?? 0,
		mergedIntoPurchaseOrderId: merged_into_purchase_order_id,
		mergeSourcesCount: merge_sources_count ?? 0,
		mergeSourcesNames: merge_sources_names ?? [],
	}
}

export const CreatePurchaseOrderToPayload = (obj: {
	deliveryDate?: Date
	parentID?: number
	facilityId: string
}): ICreatePurchaseOrderRequest => ({
	parent_id: obj.parentID,
	delivery_deadline: obj.deliveryDate ? dateToFilterFormat(obj.deliveryDate) : undefined,
	facility_id: obj.facilityId,
})
